<template>
  <div id="vue-app">
    <div
      data-swiftype-index="true"
      class="entry-content"
    >
      <!-- Document finder -->
      <section class="mtl">
        <div class="row mtl">
          <div class="large-24 columns">
            <ResidencyWaiver 
              v-if="!loading"
              :jobs="jobs"
              :query="query"
            />
            <div
              v-if="loading"
              class="loading-icon ptxl center"
            >
              <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
            </div>
          </div>
        </div>
      </section>
      <!-- Document finder -->
    </div> <!-- End .entry-content -->
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import ResidencyWaiver from './components/ResidencyWaiver.vue';
import { ClientTable } from 'vue-tables-2';
import moment from 'moment';

Vue.use(ClientTable, {
  options: {}, 
  useVuex: false,
  theme: 'bootstrap3',
  template: 'default',
});

export default {
  name: 'App',
  components: {
    ResidencyWaiver,
  },
  data () {
    return {
      api: {
        endpoint: process.env.VUE_APP_API_ENDPOINT,
      },
      jobs: [],
      query: null,
      loading: false,
    };
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    getJobs () {
      let vm = this;
      return axios.get(vm.api.endpoint).then(async (result) => {
        result.data.rows.forEach( function(job) {
          job['class_title'] = job['title'];
          job['date_signed'] = moment(job['date_app']);
        });
        vm.jobs = result.data.rows;
        return true;
      }).catch(() => {
        return false;
      });
    },
    async parseQuery () {
      let vm = this;
      vm.query = vm.$route.hash;
    },
    async init () {
      let vm = this;
      vm.loading = true;
      await vm.parseQuery();
      await vm.getJobs();
      vm.loading = false;
      await vm.scrollToDiv(); 
      vm.track();
    },
    async scrollToDiv() {
      let vm = this;
      let div = vm.$route.query.table.replace(/\s+/g, '-').toLowerCase();
      if ( div ) {
        let distance = document.getElementById(div).offsetTop;
        window.scrollTo({
          top: distance,
          behavior: 'smooth',
        });
      }
    },
    track () {
      this.$gtag.event('view_item', {
        'event_category': 'ohr',
        'event_label': 'residency-waiver',
      });
    },
  },
};
</script>